import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa"; // Dropdown icon
import { useState } from "react";

const Navbar = () => {
    const [mNav, setmNav] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null); // Track which dropdown is active

    const toggleNav = () => setmNav(!mNav);

    const toggleDropdown = (section) => {
        setActiveDropdown(activeDropdown === section ? null : section); // If the same section is clicked, close it
    };

    return (
        <>
            {/* Navbar */}
            <nav className="flex items-center justify-center p-2 bg-white text-black md:font-semibold shadow-lg">
                {/* Hamburger Icon for Mobile */}
                <FaBars 
                    className="text-2xl md:hidden cursor-pointer" 
                    onClick={toggleNav} 
                />

                {/* Links for Desktop */}
                <div className="hidden md:flex space-x-8 flex-1 justify-center">
                    {/* HOME */}
                    <Link to="/" className="hover:text-yellow-500">HOME</Link>

                    {/* ABOUT US Dropdown */}
                    <Link to="/about-us" className="hover:text-yellow-500">ABOUT US</Link>
                    
                    {/* PRE-PRI Dropdown */}
                    <div className="relative">
                        <button 
                            onClick={() => toggleDropdown('prePri')} 
                            className="flex items-center hover:text-yellow-500"
                        >
                            PRE-PRI
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'prePri' && (
                            <div className="absolute top-8 left-0 bg-white text-black shadow-lg space-y-2 p-4 w-60">
                                <Link to="/pre-pri/kindergarten" className="block hover:text-yellow-500">Kindergarten/Nursery Section</Link>
                                <Link to="/pre-pri/primary" className="block hover:text-yellow-500">Primary School Section</Link>
                            </div>
                        )}
                    </div>

                    {/* SEC SECTION Dropdown */}
                    <div className="relative">
                        <button 
                            onClick={() => toggleDropdown('secSection')} 
                            className="flex items-center hover:text-yellow-500"
                        >
                            SEC SECTION
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'secSection' && (
                            <div className="absolute top-8 left-0 bg-white text-black shadow-lg space-y-2 p-4 w-60">
                                <Link to="/sec-section/junior-secondary" className="block hover:text-yellow-500">Junior Secondary</Link>
                                <Link to="/sec-section/senior-secondary" className="block hover:text-yellow-500">Senior Secondary</Link>
                            </div>
                        )}
                    </div>

                    {/* ENROLMENT Link */}
                    <Link to="/open-an-account" className="hover:text-yellow-500">ENROLMENT</Link>

                    {/* ADMISSION Dropdown */}
                    <div className="relative">
                        <button 
                            onClick={() => toggleDropdown('admission')} 
                            className="flex items-center hover:text-yellow-500"
                        >
                            ADMISSION
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'admission' && (
                            <div className="absolute top-8 left-0 bg-white text-black shadow-lg space-y-2 p-4 w-60">
                                <Link to="/admission/process" className="block hover:text-yellow-500">Process</Link>
                                <Link to="/admission/faqs" className="block hover:text-yellow-500">FAQs</Link>
                            </div>
                        )}
                    </div>

                    {/* FACILITIES/GALLERY Dropdown */}
                    <div className="relative">
                        <button 
                            onClick={() => toggleDropdown('facilities')} 
                            className="flex items-center hover:text-yellow-500"
                        >
                            FACILITIES/GALLERY
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'facilities' && (
                            <div className="absolute top-8 left-0 bg-white text-black shadow-lg space-y-2 p-4 w-60">
                                <Link to="/facilities-gallery/gallery" className="block hover:text-yellow-500">Gallery</Link>
                            </div>
                        )}
                    </div>

                    {/* RESULT PORTAL Dropdown */}
                    <div className="relative">
                        <button 
                            onClick={() => toggleDropdown('resultPortal')} 
                            className="flex items-center hover:text-yellow-500"
                        >
                            RESULT PORTAL
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'resultPortal' && (
                            <div className="absolute top-8 left-0 bg-white text-black shadow-lg space-y-2 p-4 w-60">
                                {/* <Link to="/result-portal/primary" className="block hover:text-yellow-500">Primary</Link> */}
                                <Link to="/student-login" className="block hover:text-yellow-500">Students</Link>
                                <Link to="/teacher-login" className="block hover:text-yellow-500">Teachers</Link>
                            </div>
                        )}
                    </div>
                </div>

                {/* Mobile Nav */}
                {mNav && (
                <div className="fixed inset-0 z-50 flex flex-col items-center justify-start bg-white text-black space-y-8 md:hidden overflow-y-auto max-h-full">
                    <FaTimes 
                        className="absolute top-5 right-5 text-2xl cursor-pointer" 
                        onClick={toggleNav} 
                    />
                    <Link to="/" onClick={toggleNav} className="text-xl">HOME</Link>

                    {/* ABOUT US Mobile Dropdown */}
                    
                    <Link to="/about-us" onClick={toggleNav} className="text-xl">ABOUT US</Link>

                    {/* PRE-PRI Mobile Dropdown */}
                    <div className="relative w-full">
                        <button 
                            onClick={() => toggleDropdown('prePriMobile')} 
                            className="text-xl flex items-center justify-center w-full"
                        >
                            PRE-PRI
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'prePriMobile' && (
                            <div className="space-y-2 p-4 max-h-[300px] overflow-y-auto w-full text-center">
                                <Link to="/pre-pri/kindergarten" onClick={toggleNav} className="block hover:text-yellow-500">Kindergarten/Nursery Section</Link>
                                <Link to="/pre-pri/primary" onClick={toggleNav} className="block hover:text-yellow-500">Primary School Section</Link>
                            </div>
                        )}
                    </div>

                    {/* SEC SECTION Mobile Dropdown */}
                    <div className="relative w-full">
                        <button 
                            onClick={() => toggleDropdown('secSectionMobile')} 
                            className="text-xl flex items-center justify-center w-full"
                        >
                            SEC SECTION
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'secSectionMobile' && (
                            <div className="space-y-2 p-4 max-h-[300px] overflow-y-auto w-full text-center">
                                <Link to="/sec-section/junior-secondary" onClick={toggleNav} className="block hover:text-yellow-500">Junior Secondary Section</Link>
                                <Link to="/sec-section/senior-secondary" onClick={toggleNav} className="block hover:text-yellow-500">Senior Secondary Section</Link>
                            </div>
                        )}
                    </div>

                    {/* ENROLMENT Mobile Link */}
                    <Link to="/open-an-account" onClick={toggleNav} className="text-xl text-center">ENROLMENT</Link>

                    {/* ADMISSION Mobile Dropdown */}
                    <div className="relative w-full">
                        <button 
                            onClick={() => toggleDropdown('admissionMobile')} 
                            className="text-xl flex items-center justify-center w-full"
                        >
                            ADMISSION
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'admissionMobile' && (
                            <div className="space-y-2 p-4 max-h-[300px] overflow-y-auto w-full text-center">
                                <Link to="/admission/process" onClick={toggleNav} className="block hover:text-yellow-500">Process</Link>
                                <Link to="/admission/faqs" onClick={toggleNav} className="block hover:text-yellow-500">FAQs</Link>
                            </div>
                        )}
                    </div>

                    {/* FACILITIES/GALLERY Mobile Dropdown */}
                    <div className="relative w-full">
                        <button 
                            onClick={() => toggleDropdown('facilitiesMobile')} 
                            className="text-xl flex items-center justify-center w-full"
                        >
                            FACILITIES/GALLERY
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'facilitiesMobile' && (
                            <div className="space-y-2 p-4 max-h-[300px] overflow-y-auto w-full text-center">
                                <Link to="/facilities-gallery/gallery" onClick={toggleNav} className="block hover:text-yellow-500">Gallery</Link>
                            </div>
                        )}
                    </div>

                    {/* RESULT PORTAL Mobile Dropdown */}
                    <div className="relative w-full">
                        <button 
                            onClick={() => toggleDropdown('resultPortalMobile')} 
                            className="text-xl flex items-center justify-center w-full"
                        >
                            RESULT PORTAL
                            <FaChevronDown className="ml-1" />
                        </button>
                        {activeDropdown === 'resultPortalMobile' && (
                            <div className="space-y-2 p-4 max-h-[300px] overflow-y-auto w-full text-center">
                            <Link to="/student-login" className="block hover:text-yellow-500">Students</Link>
                            <Link to="/teacher-login" className="block hover:text-yellow-500">Teachers</Link>
                            </div>
                        )}
                    </div>
                </div>
            )}

            </nav>
        </>
    );
};

export default Navbar;
